export const TERMS_LINK_STYLES = {
  '& a[href*="destination_url_field=terms_and_fees_link"]': {
    color: 'greens.dark',
    textDecoration: 'underline',
  },
} as const;
